import {MODALS} from 'common/domain/constants';
import slashDateFilter from 'common/filters/slashDate';

const slashDate = slashDateFilter();

class VacationScheduleEndDateHelper {
  constructor(startDate, endDate, availableVacations) {
    'ngInject';
    this.startDate = startDate;
    this.endDate = endDate;
    this.availableVacations = availableVacations;

    this.dateOfStartDate = new Date(this.startDate);
    this.dateOfEndDate = new Date(this.endDate);
    this.modal = angular.element(MODALS.WARNING_REQUEST_VACATION);
    this.coachMarkModal = angular.element(MODALS.COACHMARK);
  }

  getViewDate() {
    return slashDate(this.endDate);
  }

  start() {
    if (!this.shouldBeVisible(this.dateOfStartDate, this.dateOfEndDate, this.availableVacations)) {
      return false;
    }

    if (this.coachMarkIsPresent(this.coachMarkModal)) {
      this.coachMarkModal.on('hidden.bs.modal', () => this.showModal(this.modal));
    } else {
      this.showModal(this.modal);
    }

    return true;
  }

  showModal(modal) {
    modal.modal('show');
  }

  shouldBeVisible(startDate, endDate) {
    const today = new Date();
    endDate.setDate(endDate.getDate() + 1);
    const dateStarted = (today >= startDate);
    const dateNotPassed = (today <= endDate);
    const todayDateIsInsideThePeriod = dateStarted && dateNotPassed;
    return todayDateIsInsideThePeriod;
  }

  coachMarkIsPresent(coachMarkModal) {
    return coachMarkModal.hasClass('in');
  }
}

export default VacationScheduleEndDateHelper;



// WEBPACK FOOTER //
// ./client/app/vacations-absences.module/features/myVacations/vacationScheduleEndDate.helper.js